<template>
  <div class="h-full" v-loading="loading">
    <div class="text-right mb-20px">
      <el-button type="primary" size="small" @click="filterTable(!showAll)">{{
        showAll ? $t('仅查看扣分项') : $t('查看所有')
      }}</el-button>
      <el-button type="primary" size="small" @click="download">{{ $t('导出') }}</el-button>
    </div>
    <el-form :model="form" ref="form" class="h-[calc(100%-56px)]">
      <el-table
        :data="form.tableData"
        border
        stripe
        row-key="id"
        height="100%"
        ref="table"
        :cell-class-name="getRowClassName"
        :show-summary="true"
        :sum-text="`${$t('小计')}`"
        :summary-method="getSummaryMethod"
      >
        <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
        <el-table-column type="index" width="60" :label="`${$t('序号')}`"></el-table-column>
        <el-table-column prop="project" :label="`${$t('评价项目')}`" width="120"></el-table-column>
        <el-table-column prop="content" :label="`${$t('评价内容')}`"></el-table-column>
        <el-table-column
          prop="standardScore"
          :label="`${$t('评分(100分)')}`"
          width="100"
        ></el-table-column>
        <el-table-column prop="scoringStandard" :label="`${$t('评分标准')}`"></el-table-column>
        <el-table-column :label="`${$t('评审情况')}`">
          <template slot-scope="scope">
            <el-form-item
              label=""
              label-width="0"
              class="mt-20px"
              :prop="`tableData[${scope.$index}].evaluationContent`"
              :rules="[
                {
                  required: !disabled && !scope.row.isDisconnected,
                  message: `${$t('请填写评审情况')}`,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="scope.row.evaluationContent"
                :placeholder="`${$t('请输入')}`"
                :maxlength="1000"
                show-word-limit
                :autosize="{ minRows: 4 }"
                type="textarea"
                :disabled="disabled || scope.row.isDisconnected"
                @change="saveChange(scope.row)"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          prop="score"
          :label="`${$t(source === 2 ? '评审得分' : '自评得分')}`"
          width="100"
        >
          <template slot-scope="scope">
            <el-form-item
              label=""
              label-width="0"
              class="mt-20px"
              :prop="`tableData[${scope.$index}].score`"
              :rules="[
                {
                  required: !disabled && !scope.row.isDisconnected,
                  message: `${$t('请填写自评得分')}`,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input-number
                v-model="scope.row.score"
                :placeholder="`${$t('请输入')}`"
                :min="0"
                :max="scope.row.standardScore"
                :controls="false"
                :disabled="disabled || scope.row.isDisconnected"
                class="!w-full"
                @change="saveChange(scope.row)"
              ></el-input-number>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          prop="relatedPartyAndConstructionUnitEvaluationContent"
          :label="`${$t('单位自评情况')}`"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.relatedPartyAndConstructionUnitEvaluationContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="relatedPartyAndConstructionUnitScore" :label="`${$t('自评得分')}`">
          <template slot-scope="scope">
            <div v-html="scope.row.relatedPartyAndConstructionUnitScoreHtml"></div>
          </template>
        </el-table-column>
        <el-table-column :label="`${$t('操作')}`" width="120">
          <template slot-scope="scope">
            <div class="flex justify-center flex-wrap">
              <el-button @click="operate('view', scope.row)" size="mini">{{
                $t('查看问题')
              }}</el-button>
              <el-button @click="toModule(scope.row)" size="mini" class="!ml-0px mt-10px">{{
                $t('模块跳转')
              }}</el-button>
              <el-button
                @click="operate('add', scope.row)"
                size="mini"
                v-if="!disabled && !scope.row.isDisconnected"
                class="!ml-0px mt-10px"
                >{{ $t('发现问题') }}</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <question-dialog
      :visible.sync="questionDialogVisible"
      :mode="dialogMode"
      :standardName="standardName"
      :list="questionList"
      :id="id"
      @save="getTableData"
    />
  </div>
</template>

<script>
import { SafetyEvaluationSolutionApi } from '@wiz-api/safety-evaluation-management'
import { OrganizationApi } from '@wiz-api/abp-identity'
import { filter, sumBy, map, find, forEach } from 'lodash'
import { treeToOneArray } from '@/assets/js/common/common'
import { download } from '@/assets/js/CommonDownload'

const QuestionDialog = () => {
  return import('./QuestionDialog')
}
const safetyEvaluationSolutionApi = new SafetyEvaluationSolutionApi()
const organizationApi = new OrganizationApi()
export default {
  components: {
    QuestionDialog,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    nodeId: {
      type: String,
      default: '',
    },
    nodeData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '评价信息',
    },
    standardName: {
      type: String,
      default: '',
    },
    source: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      form: {
        tableData: [],
      },
      loading: false,
      questionDialogVisible: false,
      dialogMode: '',
      questionList: [],
      showAll: true,
      evaluateList: [],
      departmentList: [],
      flattenDepartment: [],
      initTableData: [],
    }
  },
  watch: {
    id: {
      immediate: true,
      async handler(val) {
        if (this.departmentList.length === 0) {
          await this.getOrgData()
        }
        if (val) {
          this.getTableData()
        }
      },
    },
    nodeId(val) {
      if (val) {
        this.$nextTick(() => {
          this.scrollToRow()
        })
      }
    },
    nodeData: {
      handler(newValue) {
        if (newValue && !this.nodeId) {
          this.filterTableList()
        }
      },
      deep: true,
    },
  },
  methods: {
    /**
     * @description 跳转到对应模块
     */
    toModule(row) {
      if (!row.relationModule) {
        this.$message.warning('当前数据不存在模块路由')
        return
      }
      window.open(`/#${row.relationModule}`)
    },

    /**
     * @description 列表数据过滤
     */
    filterTableList() {
      if (!this.nodeData) return
      let recursionProperty = '' // 递归属性
      if (Reflect.has(this.nodeData, 'subs')) {
        recursionProperty = 'subs'
      }
      if (Reflect.has(this.nodeData, 'childs')) {
        recursionProperty = 'childs'
      }
      const nodeIds = this.getRecursionPropertyData(
        this.nodeData,
        recursionProperty,
        'safetyEvaluationId'
      )
      this.form.tableData = _.filter(this.initTableData, (item) => {
        return nodeIds.includes(item.safetyEvaluationId)
      })
    },

    /**
     * @description 递归获取该属性下所有数据
     * @param {Object} sourceData 源数据
     * @param {String} recursionProperty 递归属性
     * @param {String} valueProperty 取值属性
     * @returns {Array} 递归的该属性下所有数据
     */
    getRecursionPropertyData(sourceData, recursionProperty, valueProperty) {
      if (!sourceData[recursionProperty]?.length) {
        return []
      }
      const list = []
      sourceData[recursionProperty].forEach((item) => {
        if (item[valueProperty]) {
          list.push(item[valueProperty])
        }
        const childList = this.getRecursionPropertyData(item, recursionProperty, valueProperty)
        list.push(...childList)
      })
      return [...list]
    },

    async download() {
      const [err, res] = await safetyEvaluationSolutionApi.callExport(this.id)
      if (!err) {
        download(
          `${this.name}`,
          res,
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        )
      }
    },
    filterTable(bool) {
      this.showAll = bool
      if (this.showAll) {
        this.form.tableData = this.evaluateList
      } else {
        this.form.tableData = filter(this.evaluateList, (item) => {
          return item.score < item.standardScore
        })
      }
      this.initTableData = [...this.form.tableData]
    },
    saveChange(row) {
      if (row.evaluationContent) {
        safetyEvaluationSolutionApi.evaluate(this.id, row.id, {
          body: {
            evaluationContent: row.evaluationContent,
            score: row.score,
            problem: row.problem,
          },
        })
      }
    },
    getRowClassName({ row, column }) {
      let str = ''
      if (row.safetyEvaluationId === this.nodeId) {
        str += 'active-current-row'
      }
      if (row.isDisconnected && column.label !== '操作') {
        str += 'is-disconnected'
      }
      return str
    },
    getSummaryMethod({ columns, data }) {
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计'
        } else if (
          column.property === 'score' ||
          column.property === 'relatedPartyAndConstructionUnitScore'
        ) {
          sums[index] = sumBy(data, column.property)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    scrollToRow() {
      // const activeCells = document.getElementsByClassName('active-current-row')
      // if (activeCells.length) {
      //   activeCells[0].scrollIntoView(true)
      // }
      if (!this.nodeId) return
      this.form.tableData = _.filter(this.initTableData, (item) => {
        return item.safetyEvaluationId === this.nodeId
      })
    },
    async getTableData() {
      this.loading = true
      const [err, res] = await safetyEvaluationSolutionApi.getEvaluationsById(this.id)
      this.loading = false
      if (!err) {
        this.evaluateList = map(res, (item) => {
          const contentList = []
          const scoreList = []
          forEach(item.relatedPartyAndConstructionUnitEvaluationContent, (evaluation) => {
            const orgName =
              find(this.flattenDepartment, { id: evaluation.organizationId })?.displayName ||
              '未知单位'
            contentList.push(`${orgName}：${evaluation.evaluationContent}`)
            scoreList.push(`${orgName}：${evaluation.score}`)
          })
          if (this.source === 2) {
            scoreList.unshift(`自评分：${item.relatedPartyAndConstructionUnitScore || 0}`)
          }
          item.relatedPartyAndConstructionUnitEvaluationContent = contentList.join('<br>')
          item.relatedPartyAndConstructionUnitScoreHtml = scoreList.join('<br>')
          return item
        })
        this.initTableData = [...this.evaluateList]
        this.filterTable(true)
        this.$nextTick(() => {
          this.scrollToRow()
        })
      }
    },
    operate(type, row) {
      this.dialogMode = type
      const filterProblem = filter(this.form.tableData, (item) => {
        return item.problem
      })
      if (type === 'view') {
        this.questionList = filterProblem
      } else {
        this.questionList = row.problem ? filterProblem : [row, ...filterProblem]
      }
      this.questionDialogVisible = true
    },
    async getOrgData() {
      const [err, res] = await organizationApi.getAllListDetails({})
      if (!err && res?.items.length) {
        this.departmentList = res?.items
        // this.departmentList = res?.items[0].children
        this.flattenDepartment = treeToOneArray(this.departmentList, 'children')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .active-current-row {
  background-color: var(--tableSelectColor) !important;
}
::v-deep .el-table .cell {
  white-space: normal !important;
}
::v-deep .is-disconnected {
  text-decoration: line-through;
}
</style>
